import { render } from "./MatriculaPublica.vue?vue&type=template&id=86cad81c"
import script from "./MatriculaPublica.vue?vue&type=script&lang=js"
export * from "./MatriculaPublica.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__